export default __webpack_public_path__ + "static/media/image22745.458a0f4f.png";